<template>
  <div>
    <!-- Password Input -->
    <div class="col form-group">
      <input
        v-model="obj.password"
        id="password"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="translation.password"
        :type="showPassword ? 'text' : 'password'"
      />

      <span class="input-show-pass pt-2 mr-4" @click="showPassword = !showPassword">
        <i class="fa fa-eye senhaIcon" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'" />
      </span>
    </div>

    <!-- Password Confirmation Input -->
    <div class="col form-group mt-5">
      <input
        id="confirmPassword"
        v-model="obj.confirmPassword"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="translation.repeatPassword"
        :type="showPassword2 ? 'text' : 'password'"
        @keyup.enter="validateFields"
      />

      <span class="input-show-pass pt-2 mr-4" @click="showPassword2 = !showPassword2">
        <i class="fa fa-eye repsenhaIcon" :class="showPassword2 ? 'fa-eye' : 'fa-eye-slash'" />
      </span>
    </div>

    <p class="pl-3" style="font-size: 0.7rem">
      <small :style="template.secondaryTheme ? 'color: white;' : ''"
        >* {{ translation.minimumCharacterPass }}</small
      >

      <br />

      <small :style="template.secondaryTheme ? 'color: white;' : ''"
        >* {{ translation.specialCharacter }}</small
      ><br />

      <small :style="template.secondaryTheme ? 'color: white;' : ''"
        >* {{ translation.oneNumber }}</small
      >
    </p>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'

export default {
  name: 'GenderAndBirthDate',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    showPassword: false,
    showPassword2: false,
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    translation() {
      return {
        attention: this.$t('common.attention'),
        password: this.$t('password.password'),
        repeatPassword: this.$t('password.repeatPassword'),
        minimumCharacterPass: this.$t('password.minimumCharacterPass'),
        specialCharacter: this.$t('password.specialCharacter'),
        oneNumber: this.$t('password.oneNumber'),
        error: {
          requiredPass: this.$t('password.requiredPass'),
          minimumCharacterPass: this.$t('password.minimumCharacterPassError'),
          specialCharacter: this.$t('password.specialCharacterError'),
          oneNumber: this.$t('password.oneNumberError'),
          differentPass: this.$t('password.differentPass'),
        },
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  methods: {
    ...mapMutations([
      'addRegistrationError',
      'clearRegistrationErrors',
      'updateRegistrationObject',
    ]),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.translation.attention,
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.password) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.error.requiredPass,
        })
        this.toastMessage = this.translation.error.requiredPass
        this.makeToast('warning')
      }

      if (this.obj.password.length < 8) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.error.minimumCharacterPass,
        })
        this.toastMessage = this.translation.error.minimumCharacterPass
        this.makeToast('warning')
      }

      if (!this.containsNumbers(this.obj.password)) {
        hasErrors = true
        this.addRegistrationError({
          msg: this.translation.error.oneNumber,
        })
        this.toastMessage = this.translation.error.oneNumber
        this.makeToast('warning')
      }

      if (!this.containsSpecialCharacters(this.obj.password)) {
        hasErrors = true
        this.addRegistrationError({
          msg: this.translation.error.specialCharacter,
        })
        this.toastMessage = this.translation.error.specialCharacter
        this.makeToast('warning')
      }

      if (this.obj.password != this.obj.confirmPassword) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.error.differentPass,
        })
        this.toastMessage = this.translation.error.differentPass
        this.makeToast('warning')
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
    containsNumbers(str) {
      return /[0-9]/.test(str)
    },
    containsSpecialCharacters(str) {
      // eslint-disable-next-line no-useless-escape
      const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/

      return specialChars.test(str)
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('password').focus()
  },
}
</script>
